import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import '../Weekly/weekly.css'

// Terms / Privacy etc. opened from /weekly, shown in the same phone-width shell.
function WeeklyPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [content, setContent] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setContent(null);
    setFailed(false);
    axios.get(`${process.env.REACT_APP_API_URL}/pages`, {
      headers: {
        Authorization: localStorage.getItem('dastaan__token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      const page = (res.data?.data || []).find((item) => item.page_name === id);
      if (page) setContent(page.content || '');
      else setFailed(true);
    }).catch(() => setFailed(true));
  }, [id]);

  const goBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate('/new/weekly', { replace: true });
  };

  return (
    <div className='weekly-page'>
      <div className='weekly-page__inner'>
        <div className='weekly-page__header'>
          <button type='button' className='weekly-page__back' onClick={goBack} aria-label='Back'>
            <svg viewBox='0 0 24 24' width='22' height='22' aria-hidden='true'>
              <path d='M15 18l-6-6 6-6' fill='none' stroke='currentColor' strokeWidth='2.4' strokeLinecap='round' strokeLinejoin='round' />
            </svg>
          </button>
          <img
            className='weekly-page__logo'
            src={`${process.env.PUBLIC_URL}/logo/Dastaan_logo.png`}
            alt="Dastaan"
            title="Dastaan"
          />
        </div>

        <h1 className='weekly-doc__title'>{id}</h1>

        {failed ? (
          <span className='weekly-page__subtitle'>Couldn't load this page. Please try again.</span>
        ) : content === null ? (
          <div className='weekly-page__spinner' />
        ) : (
          <div
            className='weekly-doc__body'
            dangerouslySetInnerHTML={{ __html: content.replace(/(<? *script)/gi, 'illegalscript') }}
          />
        )}
      </div>
    </div>
  );
}

export default WeeklyPage
